module.exports = __webpack_public_path__ + "media/scheduling_tier_help/calendar-e416a63c.png";